var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgOpera = function SvgOpera(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip0_3782_13330)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip1_3782_13330)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.998 9a8.964 8.964 0 01-3.003 6.706c-2.308 1.124-4.46.336-5.171-.156 2.267-.496 3.979-3.235 3.979-6.55 0-3.316-1.712-6.055-3.98-6.555.713-.492 2.864-1.28 5.172-.156a8.986 8.986 0 013.003 6.71z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.037 3.929C5.04 5.104 4.4 6.84 4.357 8.792v.423c.044 1.948.688 3.684 1.684 4.86 1.291 1.675 3.207 2.739 5.35 2.739 1.32 0 2.552-.4 3.608-1.1a8.976 8.976 0 01-6.427 2.275C3.802 17.762.002 13.826.002 9A8.996 8.996 0 019 .001h.036a8.946 8.946 0 015.963 2.292 6.494 6.494 0 00-3.608-1.104c-2.143 0-4.059 1.064-5.354 2.74z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip0_3782_13330"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h18v18H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip1_3782_13330"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h18v18H0z"
  })))));
};
export default SvgOpera;